module.exports = __webpack_public_path__ + "static/media/exchange_dark.91d87c23.svg";